
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/s/[storeId]",
      function () {
        return require("private-next-pages/s/[storeId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/s/[storeId]"])
      });
    }
  